module.exports = __webpack_public_path__ + "static/media/pattern_a.d4d574be.svg";